import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Deployment } from '../../models/deploy/deployment';
import { FabricService } from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'deployment-resources';

@Injectable({
  providedIn: 'root'
})
export class DeploymentsService {

  constructor(private fabricService: FabricService) {

  }

  createAndDeploy(deployment: Deployment): Observable<Deployment> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_deployments', deployment);
  }

  createAndDeployDemoInstance(deployment: Deployment): Observable<Deployment> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_deployments_create-demo', {
      solutionId: deployment.solutionId,
      region: deployment.region,
      name: deployment.name,
      capabilities: deployment.capabilities
    });
  }

  updateCapabilities(deployment: Deployment): Observable<Deployment> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_instances_id_update-svc-definition', {
      id: deployment.id,
      capabilities: deployment.capabilities
    });
  }

}
